import { useEffect, useState } from "react";

/**
 * returns true if keyboard is open in mobile browsers
 */
const useKeyboardOpen = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsKeyboardOpen(window.innerHeight < window.outerHeight);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isKeyboardOpen;
};

export default useKeyboardOpen;
